export const ResolutionStringEnum = {
  Resolved: 'Resolved',
  Unresolved: 'Unresolved',
  Delighted: 'Delighted',
  Indifferent: 'Indifferent',
  RiskOfDefection: 'Risk of Defection',
};
